import { spinner } from "../../../components/spinner";
import { debounce } from "../../../components/debounce";

const miniCartToggler = document.querySelector("#offcanvas-cart-toggler") || false;
export const miniCartTogglerTooltip = (() => {
	if (!miniCartToggler) return;

	const emptyText = "Geen items in je winkelmand";
	document.addEventListener("wc_fragments_loaded", updateMiniCartTooltip);
	document.addEventListener("wc_cart_emptied", () => {
		miniCartToggler.title = emptyText;
	});

	/**
	 * Update the tooltip for the mini-cart icon
	 */
	function updateMiniCartTooltip() {
		let contents = document.querySelector("span.cart-content").innerText;
		miniCartToggler.title = `Items in winkelmand: ${contents}`;

		if (contents == "") {
			miniCartToggler.title = emptyText;
		}
	}
})();

// Make mini cart do Quantity Step
export const miniCartQuantityStep = (() => {
	// The mini cart
	const miniCart = document.querySelector("#offcanvas-cart") || false;

	// If the mini cart is there
	if (!miniCart) return;

	// Mini cart does not react to change, so we use input and click
	["input", "click"].forEach((event) => {
		miniCart.addEventListener(event, (e) => {
			// If the event is click, but not on a qty button, return
			if (event === "click" && !e.target.classList.contains("qty_button")) return;

			// If the event is input, but the input is null (like backspace)
			if (e.inputType == "deleteContentBackward" || e.inputType == "deleteContentForward") return;

			// Throw the adding_to_cart event
			document.dispatchEvent(new CustomEvent("adding_to_cart"));

			// Get the product id
			let qtyParent = e.target.closest("[data-cart-item-key]");
			let id = qtyParent.dataset.cartItemKey;

			// Debounce to make sure it doesn't run when adding or removing more than one
			debounce(updateMiniCart, 350);

			/**
			 * Update the mini cart on quantity step
			 * @returns {mixed} void Updates the mini-cart html and dispatches added_to_cart event
			 */
			function updateMiniCart() {
				// Get spinner
				const loader = document.createElement("div");
				loader.classList.add("px-2", "align-self-center");
				loader.innerHTML = spinner().outerHTML;

				// Append to parent
				qtyParent.append(loader);

				// Disable buttons during ajax call
				const allButtons = document.querySelectorAll(".qty_button");
				allButtons.forEach((button) => (button.disabled = true));

				// Disable all inputs during ajax call
				const allInputs = miniCart.querySelectorAll("input");
				allInputs.forEach((input) => (input.disabled = true));

				// Add form data
				let data = new FormData();
				data.append("action", "mini_cart_update_quantity");
				data.append("quantity", qtyParent.querySelector(".qty").value);
				data.append("cart_item_key", id);

				// Make ajax call
				fetch(woocommerce_params.ajax_url, {
					method: "POST",
					body: data,
				})
					.then((response) => response.json())
					.then((data) => {
						updateMiniCartHTML(data);
						// Enable buttons & inputs again
						allButtons.forEach((button) => (button.disabled = false));
						allInputs.forEach((input) => (input.disabled = false));

						document.dispatchEvent(new CustomEvent("added_to_cart", { detail: data.fragments }));
					});
			}
		});
	});
})();

export const getFragmentsOnLoad = (() => {
	if (!miniCartToggler) return;

	document.addEventListener("DOMContentLoaded", function (e) {
		fetch(woocommerce_params.wc_ajax_url.replace("%%endpoint%%", "get_refreshed_fragments"), {
			method: "POST",
		})
			.then((response) => response.json())
			.then((data) => {
				updateMiniCartHTML(data);
			});
	});
})();

/**
 * Updates the minicart when needed
 *
 * @param {object} data
 */
function updateMiniCartHTML(data) {
	const isCart = typeof wc_add_to_cart_params === "object" && wc_add_to_cart_params.is_cart == 1;

	if (!data.fragments || isCart) return; // Return quietly

	document.querySelector(".widget_shopping_cart_content").outerHTML = data.fragments["div.widget_shopping_cart_content"];
	document.querySelector("span.cart-content").innerHTML = data.fragments["span.cart-content"];

	const notices = data.fragments["notices_html"] || false;

	if (notices) {
		document.querySelector(".woocommerce-notices-wrapper").innerHTML = notices;
	}
}
